import React, { useEffect } from 'react';
import { useState } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonFooter, IonPage, IonTitle, IonToolbar, IonMenuToggle, IonModal, IonButton, IonIcon, IonLabel } from '@ionic/react';
import { useIonViewWillEnter, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { Row, Col, Button, Accordion } from 'react-bootstrap';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faUpload, faRotate } from '@fortawesome/free-solid-svg-icons';
import { Avatar, Loader, CustomTable, CustomModal } from 'citric_components';
import Menubar from '../Dashboard/Menubar';
import ReleasesAdmContent from '../Releases/ReleasesAdmContent';
import Create from './Create';
import Update from './Update';
import { App } from '@capacitor/app';

import CardImg from '../../images/card.png';
import { useNavigate } from 'react-router';

import conf from '../../config.json';
import { formatDate, logD } from '../Util/Util';
import i18next from 'i18next';
import Upload from './Upload';

export default function BrandLift(props) {
    logD("ReleasesAdm", props);
    //const launchs = props.project.releases;
    const [launchs, setLaunchs] = useState(props.project.brandlifts);
    const [releases, setReleases] = useState(props.project.releases);

    const project = props.project;
    const projects = props.projects;
    const [modalOpen, setModalOpen] = useState(false);
    const [modalUploadOpen, setModalUploadOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [summaries, setSummaries] = useState([]);

    //Create modal
    const [createModal, setCreateModal] = useState(false);
    //Update modal
    const [updateModal, setUpdateModal] = useState(false);
    //Upload modal
    const [uploadModal, setUploadModal] = useState(false);
    //Delete modal
    //const [deleteModal, setDeleteModal] = useState(false);
    //Modal show flag
    const [show, setShow] = useState(false);
    //Modal show/close methods
    const handleShow = () => setShow(true);

    function handleClose() {
        setCreateModal(false);
        setUpdateModal(false);
        setUploadModal(false);
        //setDeleteModal(false);
        setShow(false);
    }

    //Table actions
    function handleCreate() {
        console.log('create');
        setCreateModal(true);
        handleShow();
    }

    function handleUpdate(row) {
        console.log(row);
        setSelected(row);
        setUpdateModal(true);
        handleShow();
    }

    function handleUpload(row) {
        console.log(row);
        setSelected(row);
        setUploadModal(true);
        handleShow();
    }

    //Modal actions
    function handleFinish() {
        console.log('finish');
        handleClose();
        getReleases(project);
    }

    const navigate = useNavigate();

    function back() {
        props.setCustomer(null);
        //props.setProject(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    useIonViewDidEnter(async () => {
        App.addListener('backButton', ({canGoBack}) => {
            
            if(!canGoBack){
                App.exitApp();
            } else {
                back();
            }
        });
    });

    function loadRelease(item) {
        console.log('loadPRelease');
        console.log(item);
        props.setRelease(item);
        setTimeout(function(){
            navigate('../release/'+item.idDraft);
        }, 100);
    }

    function downloadFile(type, bl) {
        console.log(type + " " + bl);
        let fd = new URLSearchParams();
        fd.append("idU", props.token.u);
        fd.append("idBl", bl.idBrandlift);
        fd.append("type", type);

        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/downloadFileBl';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => response.blob())
        .then((res) => {
            console.log(res);
            var file = window.URL.createObjectURL(res);
            var link = document.createElement("a");
            link.href = file;
            var ext = 'xlsx';
            var suffix = 'EXP';
            if(type == 2) {
                ext = 'xlsx';
                suffix = 'NE';
            } else if(type == 3) {
                ext = 'pptx';
                suffix = 'REPORT';
            }
            link.download = bl.name + '_' + suffix + '.' + ext;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            //setShowGenerate(false);
            //window.location.assign(file);
            /*Object.assign(document.createElement('a'), {
                file,
                download: 'seedtag.pptx',
              }).click();*/
        }).catch((e) => {
            props.handleError(e);
        });
    }

    function getLaunchs(item) {
        setLaunchs(null);
        let fd = new URLSearchParams();
        fd.append("idU", props.token.u);
        fd.append("idR", item.idDraft);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allLaunchs';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        .then((data) => {
            logD("Releases", data);
            loadRelease(data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function getReleases(item) {
        setLaunchs(null);
        let fd = new URLSearchParams();
        fd.append("idC", props.token.c);
        fd.append("idU", props.token.u);
        fd.append("idP", item.idProject);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allReleases';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        .then((data) => {
            setLaunchs(data.brandlifts);
            if(props.token.r == 1) {
                setReleases(data.releases);
            }
            props.setProject(data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function reload() {
        setLaunchs(null);
        setReleases(null);
        getReleases(project);
    }

    useEffect(() => {
        if(launchs == null || launchs.length == 0) {
            getReleases(project);
        }
    }, [props]);


    const columns = [
        {
            Header: t('id'),
            accessor: 'code',
        },
        {
            Header: t('budget'),
            accessor: 'budget',
        },
        {
            Header: t('invoice'),
            accessor: 'invoice',
        },
        {
            Header: t('tracking'),
            id: 'actions2',
            accessor: (d) => {
                return <>
                    {d.idExp != null && <IonButton color="secondary" onClick={(e) => {
                            e.preventDefault();
                            props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + d.idProject + '&sv=' + d.idExp + '&qa=1&nomb=1');
                            props.setTitle(t('tracking'));
                            props.setTypeUrl('tracking');
                            setTimeout(function(){
                                navigate('../webview/'+d.idExp);
                            }, 100);
                        }
                    }>{t('output_exp')}</IonButton>}
                    {d.idNe != null && <IonButton color="secondary" onClick={(e) => {
                            e.preventDefault();
                            props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + d.idProject + '&sv=' + d.idNe + '&qa=1&nomb=1');
                            props.setTitle(t('tracking'));
                            props.setTypeUrl('tracking');
                            setTimeout(function(){
                                navigate('../webview/'+d.idNe);
                            }, 100);
                        }
                    }>{t('output_ne')}</IonButton>}
                </>
            },
        },
        {
            Header: t('downloads'),
            id: 'actions',
            Cell: row => (
                <>
                    {console.log(row)}
                    { props.token.r == 1 &&
                        <IonButton onClick={e=> handleUpdate(row.row.original)}><FontAwesomeIcon icon={faEdit} /></IonButton>
                    }
                    { props.token.r == 1 &&
                        <IonButton onClick={e=> handleUpload(row.row.original)}><FontAwesomeIcon icon={faUpload} /></IonButton>
                    }
                    { row.row.original.outputExp != null &&
                        <IonButton color="primary" onClick={(e) => {
                                e.preventDefault();
                                downloadFile(1, row.row.original)
                            }
                        }>
                            {t('output_exp')}
                        </IonButton>
                    }
                    { row.row.original.outputNe != null &&
                        <IonButton color="primary" onClick={(e) => {
                                e.preventDefault();
                                downloadFile(2, row.row.original)
                            }
                        }>
                            {t('output_ne')}
                        </IonButton>
                    }
                    { row.row.original.report != null &&
                        <IonButton color="primary" onClick={(e) => {
                                e.preventDefault();
                                downloadFile(3, row.row.original)
                            }
                        }>
                            {t('report')}
                        </IonButton>
                    }
                </>
            ),
        },
        {
            Header: t('name'),
            accessor: 'name',
        },
        {
            id: 'started',
            Header: t('start'),
            sortType: (a, b) => {
                return b.original.started - a.original.started;
            },
            accessor: (d) => {
                if(d.started == null) {
                    return '';
                } else {
                    return new Date(d.started).toLocaleDateString(navigator.language);
                }
            },

        },
        {
            Header: t('amount'),
            id: 'amount',
            accessor: (d) => {
                return parseFloat(d.amount).toFixed(2);
            }
        },
        {
            Header: t('vat'),
            accessor: 'vat',
        },
        {
            Header: t('total'),
            id: 'total',
            accessor: (d) => {
                return parseFloat(d.amount * (1 + (d.vat / 100))).toFixed(2);
            }
        },
        {
            Header: t('invoice_state'),
            id: 'invoice_state',
            accessor: (d) => {
                if(d.idInvoiceState == 1) {
                    return t('pending')
                } else if(d.idInvoiceState == 2) {
                    return t('paid')
                } else if(d.idInvoiceState == 3) {
                    return t('past_due')
                }
            }
        },
        {
            Header: t('state'),
            accessor: (d) => {
                if(d.idState == 1) {
                    return t('launched')
                } else if(d.idState == 2) {
                    return t('submited')
                } else if(d.idState == 3) {
                    return t('invoiced')
                } else if(d.idState == 4) {
                    return t('paid')
                } else if(d.idState == 5) {
                    return t('finished')
                }
            }
        },
        {
            Header: t('channels'),
            accessor: 'channels',
        },
        {
            Header: t('current_exp'),
            accessor: 'currentExp',
        },
        {
            Header: t('total_exp'),
            accessor: 'totalExp',
        },
        {
            Header: t('current_ne'),
            accessor: 'currentNe',
        },
        {
            Header: t('total_ne'),
            accessor: 'totalNe',
        },
    ];

    var hiddenColumns = ['budget', 'invoice', 'amount', 'vat', 'total', 'invoice_state'];

    if(props.token.r == 1) {
        hiddenColumns = [];
    }
    
    return (
        <>
            { props.token.r != 1 && projects.length == 1 && <Menubar lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken} contentId="brandLiftAdm"/> }
            <IonPage id="brandLiftAdm">
                <IonHeader>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            { props.token.r != 1 && projects.length == 1 &&
                                <IonMenuToggle className="ion-padding-start">
                                    <Avatar name={props.token.name.charAt(0).toUpperCase()}/>
                                </IonMenuToggle>
                            }
                            { (projects.length > 1 || props.token.r == 1) &&
                                <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                            }
                        </IonButtons>
                        <IonTitle>{t('brandlift_projects')}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <Row className="text-end">
                        <Col>
                            <Button variant="link"><FontAwesomeIcon icon={faRotate} onClick={() => reload()}/></Button>
                        </Col>
                    </Row>
                    {launchs == null && <Loader />}
                    {
                        releases != null && props.token.r == 1 && 
                        <Accordion alwaysOpen activeKey={"0"} className='mt-1 mb-2'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><div className="vr px-1 color-orange opacity-100 mx-1"></div><h5>{t('surveys')}</h5></Accordion.Header>
                                <Accordion.Body>
                                    <ReleasesAdmContent project={props.project} releases={releases} lang={props.lang} setLang={props.setLang} token={props.token} setUrl={props.setUrl} setTitle={props.setTitle} setTypeUrl={props.setTypeUrl} 
                                    setProject={props.setProject} setRelease={props.setRelease} setToken={props.setToken} handleError={props.handleError} setCustomer={props.setCustomer} setShowToast={props.setShowToast} 
                                    loadRelease={loadRelease} />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    }
                    {
                        launchs != null &&
                        <>
                        <CustomTable keyField='id' desc={false} data={launchs} columns={columns} isFilter={true} isPagination={true} isSelection={false} hasActions={props.token.r == 1 ? true : false} hiddenColumns={hiddenColumns} isExport={true} create={handleCreate}/>
                        {show && createModal && <CustomModal id='createBrandlift' className="big-modal" title={t('brandlift')} body={ <Create token={props.token.token} handleFinish={handleFinish} handleError={props.handleError} project={props.project.idProject}/>} show={show} handleClose={handleClose}/>}
                        {show && updateModal && <CustomModal id='updateBrandlift' className="big-modal" title={t('brandlift')} body={ <Update token={props.token.token} handleFinish={handleFinish} handleError={props.handleError} selected={selected} project={props.project.idProject}/>} show={show} handleClose={handleClose}/>}
                        {show && uploadModal && <CustomModal id='uploadBrandlift' className="big-modal" title={t('brandlift')} body={ <Upload token={props.token.token} handleFinish={handleFinish} handleError={props.handleError} selected={selected} project={props.project.idProject}/>} show={show} handleClose={handleClose}/>}
                        </>
                    }
                    <IonModal className="big-modal" isOpen={modalOpen}>
                        <IonHeader>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton onClick={() => setModalOpen(false)}>{t('close')}</IonButton>
                                </IonButtons>
                                <IonTitle>{t('outputs')}</IonTitle>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">

                        </IonContent>
                    </IonModal>
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle className="text-center">{t('logged_in_as')} <span className='color-orange'><b>{props.token.name}</b></span></IonTitle>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </>
    );
}